import { render, staticRenderFns } from "./detailsList.vue?vue&type=template&id=91ce6876&scoped=true&"
import script from "./detailsList.vue?vue&type=script&lang=js&"
export * from "./detailsList.vue?vue&type=script&lang=js&"
import style0 from "./detailsList.vue?vue&type=style&index=0&id=91ce6876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ce6876",
  null
  
)

export default component.exports